import { PromotionPolicy } from "@/policies";
import { auth } from "@/services";

(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller("myPromotionsController", myPromotionsController);

  myPromotionsController.$inject = [
    "Promotions",
    "PromotionsApi",
    "$rootScope",
  ];

  function myPromotionsController(Promotions, PromotionsApi, $rootScope) {
    const vm = this;
    const user = auth.user();

    // properties
    vm.policyChecks = {
      canCreate: PromotionPolicy.canCreate(user),
    };
    vm.promotions = {};
    vm.filters = {
      page: 1,
      user_id: $rootScope.thisUser.id,
    };

    // methods
    vm.createPromotion = createPromotion;
    vm.getPromotions = getPromotions;
    vm.promotionEditedCallback = promotionEditedCallback;
    vm.managePromotion = managePromotion;

    /**
     * Initialises the controller.
     *
     * @returns {void}
     */
    function bootstrap(): void {
      getPromotions();
    }

    /**
     * Loads this users' promotions from the api and caches to controller scope.
     *
     * @param {number=} page
     * @return {void}
     */
    function getPromotions(page?: number): void {
      if (page) {
        vm.filters.page = page;
      }

      PromotionsApi.get(vm.filters, (response) => {
        vm.promotions = response;
      });
    }

    /**
     * Shows the create promotion modal, then reloads promotions
     * @return {void}
     */
    function createPromotion(): void {
      Promotions.managePromotion().result.then(() => {
        getPromotions();
      });
    }

    /**
     * Called after a promotion has been edited.
     *
     * @returns {void}
     */
    function promotionEditedCallback(): void {
      getPromotions();
    }

    /**
     * Shows manage promotion modal, then reloads promotions
     * @param  {object} promotion - Promotion containing id
     * @return {void}
     */
    function managePromotion(promotion): void {
      Promotions.managePromotion(promotion.id).result.then(() => {
        getPromotions();
      });
    }

    bootstrap();
  }
})(angular);
